import { CommonModule } from "@angular/common";
import { Component, inject, model } from "@angular/core";
import {
    Button,
    Hint,
    InputChip,
    ModalAdapter,
    ModalContainer,
    ModalHeader,
} from "@malirang/front-share";

@Component({
    selector: "app-document-email-share",
    templateUrl: "./document-email-share.modal.html",
    styleUrls: ["./document-email-share.modal.css"],
    imports: [
        CommonModule,
        ModalHeader,
        ModalContainer,
        InputChip,
        Button,
        Hint,
    ],
})
export class DocumentEmailShareModal extends ModalAdapter {
    emails = model<string[]>([]);

    submit() {
        if (this.emails().length === 0) {
            return;
        }

        for (const email of this.emails()) {
            if (!email.includes("@")) {
                this.toastService.error("이메일을 제대로 입력해주세요.");
                return;
            }
        }

        this.close(this.emails());
    }
}
